export { SmartRender as default };

const SmartRender = {
  mounted(el, binding, vnode, prevVnode) {
    el.classList.add('smart-render-scroll');
  },
}
